import styled from "styled-components";
import {
  DefaultParagraphLargeFactory,
  DefaultTitleLargeFactory,
} from "../../../../components/Habitacional/core/Typograph/Typograph.Style";

export const HireSectionContainer = styled.section(({ theme }) => ({
  background: `${theme.color.brandPrimary.light} !important`,
  color: theme.color.neutral["08"],
  paddingTop: "40px",
  paddingBottom: "40px",
  marginBottom: "0 !important",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const HireSectionContent = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    gap: "64px",
    flexDirection: "row ",
  },
}));

export const HireSectionImage = styled.img(({ theme }) => ({
  maxWidth: "100%",
  width: "100%",
  height: "100%",
  objectFit: "contain",

  [theme.breakpoint.lg()]: {
    width: "384px",
    height: "384px",
  },
}));

export const HireSectionBlock = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  gap: "12px",

  [theme.breakpoint.lg()]: {
    alignItems: "flex-start",
  },

  button: {
    marginTop: "20px",
  },
}));

export const HireSectionBlockTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
}));

export const HireSectionBlockDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
}));
